export const callbackState = (iso) => {
  if (!iso) return null;
  const at = new Date(iso);
  const now = new Date();
  const endOfToday = new Date(now);
  endOfToday.setHours(23, 59, 59, 999);
  if (at <= now) return "overdue";
  if (at <= endOfToday) return "today";
  return "upcoming";
};

export const isCallbackDue = (lead) => ["overdue", "today"].includes(callbackState(lead.callback_at));

// pinned first, then due/overdue callbacks (soonest first), then server order
export const sortLeads = (leads) => {
  const rank = (l) => (l.pinned ? 0 : isCallbackDue(l) ? 1 : 2);
  return leads
    .map((l, i) => ({ l, i }))
    .sort((a, b) => {
      const r = rank(a.l) - rank(b.l);
      if (r) return r;
      if (rank(a.l) === 1) return new Date(a.l.callback_at) - new Date(b.l.callback_at);
      return a.i - b.i;
    })
    .map((x) => x.l);
};

export const fmtDateTime = (iso) => {
  try {
    return new Date(iso).toLocaleString(undefined, { weekday: "short", month: "short", day: "numeric", hour: "numeric", minute: "2-digit" });
  } catch {
    return "";
  }
};
